import { Node_Type } from "./../../ricos-types/index.js";
import Poll from "./poll.js";
const nodeViewRenderers = {
  [Node_Type.POLL]: Poll
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
